import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsx("mask", {
        id: "t8kjuupui__mask0_3_11745",
        style: {
          maskType: "alpha"
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "20",
        height: "20",
        children: _jsx("path", {
          d: "M10 19.5C4.7533 19.5 0.5 15.2467 0.5 10C0.5 4.7533 4.7533 0.5 10 0.5C15.2467 0.5 19.5 4.7533 19.5 10C19.5 15.2467 15.2467 19.5 10 19.5Z",
          fill: "#C4C4C4",
          stroke: "#152361"
        })
      }), _jsxs("g", {
        mask: "url(#t8kjuupui__mask0_3_11745)",
        children: [_jsx("path", {
          d: "M28 1H1V19H28V1Z",
          fill: "#0D5EAF"
        }), _jsx("path", {
          d: "M28 17.002H1V15.004H28V17.002ZM28 13.0015H1V11.0035H5.0005V7.003H1V5.0005H5.0005V1H6.9985V5.0005H10.999V6.9985H28V8.9965H10.999V6.9985H6.9985V10.999H28V13.0015ZM28 5.0005H10.999V2.998H28V5.0005Z",
          fill: "white"
        }), _jsx("path", {
          d: "M10 19.5C4.7533 19.5 0.5 15.2467 0.5 10C0.5 4.7533 4.7533 0.5 10 0.5C15.2467 0.5 19.5 4.7533 19.5 10C19.5 15.2467 15.2467 19.5 10 19.5Z",
          stroke: "#152361"
        })]
      })]
    }))
  });
};
export default Component;
